//utils
import { batchActions } from 'redux-batched-actions';
import {displayErrorMessage, displaySuccessMessage} from '@insticator/insticator-ui'
import {updatePageDetails, changePage} from '@insticator/insticator-ui';
// API Calls Utils
import {
    asyncGetGeneralInfo, asyncUpdateGeneralInfo,
    asyncGetUsers,
    asyncEditUserInfo, asyncDeleteUser,
    asyncAddUser, asyncInviteUser, asyncGetCheckInformation,
    asyncGetACHInformation, asyncGetPayPalInformation,
    asyncGetWireTransferInformation, asyncSavePaymentInformation,
    asyncGetPaymentInformation, asyncGetAdsTxt,
    asyncVerifyAdsTxt, getAllSitesCall, asyncUpdatePaymentInformation, asyncResendInvite
} from 'utils/api/account';
// THUNK Wrappers for API Calls
import { getFormDataOrRepopulate, updateFormDataWithValidation} from 'state/actions/formactionswrapper';
// import {batchActions} from "redux-batched-actions";
// import


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export const RECEIVE_ALL_SITES = 'RECEIVE_ALL_SITES';
export const CHANGE_PAYMENT_TYPE = 'CHANGE_PAYMENT_TYPE';
export const UPDATE_PREFERRED_PAYMENT_TYPE = 'UPDATE_PREFERRED_PAYMENT_TYPE';
export const GET_PAYMENT_INFO = "GET_PAYMENT_INFO";
export const FETCHING_PAYMENT_INFO = "FETCHING_PAYMENT_INFO";
export const UPLOAD_FILE = "UPLOAD_FILE";
export const DISCARD_FILE = "DISCARD_FILE";
export const CLEAR_CHECK_ADDRESS = "CLEAR_CHECK_ADDRESS";
export const USE_GENERAL_ADDRESS_CHECK = "USE_GENERAL_ADDRESS_CHECK";
export const GET_GENERAL_INFO_CHECK = "GET_GENERAL_INFO_CHECK";
// export const FETCHING_PAYMENT_INFO = "FETCHING_PAYMENT_INFO";

export const GET_USERS = "GET_USERS";
export const UPDATE_USER = "UPDATE_USER";
export const POPULATE_EDIT_USER_FIELD = "POPULATE_EDIT_USER_FIELD";
export const ADD_USER = "ADD_USER";
export const DELETE_USER = "DELETE_USER";
export const SENDING_INVITE = "SENDING_INVITE";
export const UPDATE_USER_STATUS = "UPDATE_USER_STATUS";

//AdsTxt
export const GET_ADS_TXT = "GET_ADS_TXT";
export const VERIFY_ADS_TXT = "VERIFY_ADS_TXT";
export const ADS_TXT_FETCHING = "ADS_TXT_FETCHING";

export const SHOW_PUBPORTAL_V2_BUTTON = "SHOW_PUBPORTAL_V2_BUTTON";
export const GET_ACCOUNT_NAME = "GET_ACCOUNT_NAME";


// ACTIONS
// TODO Put action creators in place. Replace actions with action creator calls in thunks

const receiveAllSites = sites => ({
    type: RECEIVE_ALL_SITES,
    sites
});



// -------------- ++++++++ -------------- START: THUNKS -------------- ++++++++ -------------- //


//General Information Actions
export const getGeneralInfoOrRepopulate = (hasStoredData, accountUIID) => getFormDataOrRepopulate('generalInformation', asyncGetGeneralInfo, hasStoredData, accountUIID);
export const updateGeneralInformationWithValidation = (fields, updatedData, accountUUID) => updateFormDataWithValidation('generalInformation', fields ,asyncUpdateGeneralInfo, updatedData, accountUUID);

//Edit Users Actions

const receiveUsers = users => ({
    type: GET_USERS,
    users
});
export const getUsers = (accountUUID) => dispatch => {
 return asyncGetUsers(accountUUID)
     .then(response =>{
         return dispatch(receiveUsers(response.data))
     })
     .catch(err => dispatch(displayErrorMessage('There was an issue fetching your users')))
};

const confirmUserDeleted = (index) => ({
    type: DELETE_USER,
    index
});

export const deleteUser = (userUUID, index) => dispatch => {
    return asyncDeleteUser(userUUID)
        .then(response => {
            return dispatch(confirmUserDeleted(index))
        })
        .catch(err => dispatch(displayErrorMessage('There was an issue deleting this user')))
};

export const populateEditUserForm = (data) => ({
    type: POPULATE_EDIT_USER_FIELD,
    data
});

const updateUserStatus = (userUUID, status) => ({
    type: UPDATE_USER_STATUS,
    userUUID,
    status
});

export const updateUserInformationWithValidation = (fields, updatedData, userUUID, successAction, failAction) => updateFormDataWithValidation('editUser', fields, asyncEditUserInfo, updatedData, userUUID, successAction, failAction);

export const updateTableWithNewUserInformation = (response , index) => ({type: UPDATE_USER, data:response.data, index});

//Add User Actions

export const addUser = (fields, data, accountUUID, successAction, failAction) => updateFormDataWithValidation('addUser', fields, asyncAddUser, data, accountUUID, successAction, failAction );

export const addUserToTable = (response) => ({
        type: ADD_USER,
        user: response.data
    });
//Resend Invite
//TODO delete after QA
// const sendingInvite = (userUUID) => ({
//     type: SENDING_INVITE,
//     userUUID
// });
const sendingInvite = (status) => ({
    type: SENDING_INVITE,
    status
});

export const resendInvite = (userUUID, isResend, successRoute) => dispatch => {
    //we are pushing userUUID in to the sendingInvite array in reducer
    dispatch(sendingInvite(userUUID));
    asyncResendInvite(userUUID, isResend)
        .then(response => {
            dispatch(batchActions([
                //we are splicing userUUID from the sendingInvite array in reducer
                sendingInvite(userUUID),
                displaySuccessMessage('New invitation link sent')
            ]))
        })
        .then(()=>{
            if(successRoute){
                dispatch(changePage(successRoute));
                dispatch(updatePageDetails(successRoute));
            }
        })
        .catch(() => {
            dispatch(batchActions([
                //we are splicing userUUID from the sendingInvite array in reducer
                sendingInvite(userUUID),
                displayErrorMessage('There was an issue sending invite')
            ]))
        })
};

const sendInviteSuccess = (userUUID) => batchActions([sendingInvite(false), updateUserStatus(userUUID, 'INVITE_SENT'), displaySuccessMessage('New invitation sent!')]);
const sendInviteFail = () => batchActions([sendingInvite(false), displayErrorMessage('There was an issue sending invite')]);

export const sendInvite = (userUUID) => dispatch => {
    dispatch(sendingInvite(true));
    asyncInviteUser(userUUID)
        .then(response => dispatch(sendInviteSuccess(userUUID)))
        .catch(err => dispatch(sendInviteFail()))
};

//Payment Information Actions
const receivePaymentInformation = (data) => ({
    type: GET_PAYMENT_INFO,
    payoutThreshold: data.payoutThreshold,
    paymentInfo: data.paymentInfo,
    paymentTypes: data.paymentTypes
});

export const getPaymentInformation = (accountUUID) => dispatch => {
            dispatch(fetchingPaymentInfo());
    return asyncGetPaymentInformation(accountUUID)
        .then(response =>{
            return dispatch(receivePaymentInformation(response.data))
        })
        .catch(err => dispatch(displayErrorMessage('There was an issue fetching your Payment Information')))
};

const fetchingPaymentInfo = () => ({type: FETCHING_PAYMENT_INFO});

export const getCheckInformation = (hasStoredData, formName, paymentUUID) => getFormDataOrRepopulate(formName, asyncGetCheckInformation, hasStoredData, paymentUUID );

export const getPayPalInformation = (hasStoredData, formName, accountUUID) => getFormDataOrRepopulate(formName, asyncGetPayPalInformation, hasStoredData, accountUUID );

export const getACHInformation = (hasStoredData, formName, accountUUID) => getFormDataOrRepopulate(formName, asyncGetACHInformation, hasStoredData, accountUUID );

export const discardFile = (formName) => ({ type: DISCARD_FILE, formName });

export const uploadFile = ( file, formName ) => ({ type: UPLOAD_FILE, file, formName });

export const getWireTransferInformation = (hasStoredData, formName, accountUUID) => getFormDataOrRepopulate(formName, asyncGetWireTransferInformation, hasStoredData, accountUUID );

export const savePaymentInformationWithValidation = (fields, updatedData, paymentType, accountUUID, successAction, failAction) => updateFormDataWithValidation(paymentType, fields, asyncSavePaymentInformation, updatedData, accountUUID, successAction, failAction);

export const updatePaymentInformationWithValidation = (fields, updatedData, paymentType, paymentUUID, successAction, failAction) => updateFormDataWithValidation(paymentType, fields, asyncUpdatePaymentInformation, updatedData, paymentUUID, successAction, failAction);
// -------------- ++++++++ -------------- END: THUNKS -------------- ++++++++ -------------- //


// ACTIONS THAT CAN BE IMPORTED AND USED IN COMPONENTS


export const changePaymentType = (paymentType, paymentUUID) =>({
    type: CHANGE_PAYMENT_TYPE,
    paymentType,
    paymentUUID
});

export const updatePreferredPaymentType = paymentType =>({
    type: UPDATE_PREFERRED_PAYMENT_TYPE,
    paymentType
});

export const getAllSites = accountUUID => dispatch =>{
    return getAllSitesCall(accountUUID)
        .then(response => dispatch(receiveAllSites(response.data)))
        .catch(err => dispatch(displayErrorMessage('There was an issue fetching your Sites')))
};

// -=-=-=-=--=-=-=-=-== ADStxt Thunks -=-==-=-=-=-=-=-=-=-=- //
const receiveAdsTxt = (data, site) => ({
    type: GET_ADS_TXT,
    adsTxt: data,
    site
});
export const getAdsTxt = (accountUUID, site) => dispatch => {
    dispatch(adsTxtFetching(true));
    return asyncGetAdsTxt(accountUUID, site.value)
        .then(response => {
            return dispatch(batchActions([adsTxtFetching(false),receiveAdsTxt(response.data, site)]))
        },err => dispatch(batchActions([
            adsTxtFetching(false),
            displayErrorMessage('There was an issue fetching your Ads.txt information')]
        )))
};

const adsTxtFetching = (bool) => ({type: ADS_TXT_FETCHING, bool});

const adsTxtVerification = (data) => ({
    type: VERIFY_ADS_TXT,
    adsTxt: data
});
export const verifyAdsTxt = (siteUUID) => dispatch => {
    dispatch(adsTxtFetching(true));
    return asyncVerifyAdsTxt(siteUUID)
        .then(response =>{
            return dispatch(batchActions([adsTxtFetching(false),adsTxtVerification(response.data)]))
        })
        .catch(err => dispatch(displayErrorMessage('There was an issue verifying your Ads.txt file')))
};

const showPubportalV2Button  = showPubPortalV2Button => ({
    type: SHOW_PUBPORTAL_V2_BUTTON,
    showPubPortalV2Button
});

const getAccountName = accountName => ({
    type: GET_ACCOUNT_NAME,
    accountName
});

export const getShowPubPortalV2Button = (accountUUID) => dispatch => {
    return asyncGetGeneralInfo(accountUUID)
        .then(response =>{
            const showBetaButton = response.data && response.data.showPubPortalV2Button ? response.data.showPubPortalV2Button : false;
            const accountName = response.data && response.data.accountName ? response.data.accountName : null;
            return dispatch(batchActions([showPubportalV2Button(showBetaButton), getAccountName(accountName)]));
        })
        .catch(err => dispatch(displayErrorMessage('There was an issue fetching your account information')))
};





